import consoleFourTrackers from './includes/console-four-trackers.js';
import fightcampQuickWraps from './includes/fightcamp-quick-wraps.js';
import fightcampAnkleWraps from './includes/fightcamp-ankle-wraps.js';
import fightcampBoxingBag from './includes/fightcamp-boxing-bag.js';
import fightcampBagRing from './includes/fightcamp-bag-ring.js';
import fightcampGloves from './includes/fightcamp-gloves.js';
import fightcampHeartRateMonitor from './includes/fightcamp-heart-rate-monitor.js';

export default [
  {
    testShopifyId: 'gid://shopify/Product/7977363996761',
    prodShopifyId: 'gid://shopify/Product/8945312432364',
    pathId: 'fightcamp-connect',
    title: 'Connect',
    price: '$299',
    description: 'Elevate your boxing setup with FightCamp’s core technology. Ideal for those with a bag and gloves who only need the essentials.',
    includes: [
      consoleFourTrackers,
      fightcampQuickWraps,
      fightcampAnkleWraps,
    ],
    includesBag: false,
    assets: [
      {
        src: 'https://a.storyblok.com/f/152150/1200x960/1dc2de93c3/packages_connect_above.jpg',
        alt: 'FightCamp Package',
      },
      {
        src: 'https://a.storyblok.com/f/152150/6000x4000/62f63b92c9/fc_product_shoot_2025-21.jpg',
        alt: 'FightCamp quick wraps with trackers',
      },
      {
        src: 'https://a.storyblok.com/f/152150/6000x4000/13103fd601/a15a9140.jpg',
        alt: 'FightCamp console mounted on wall, person is lifting tracker from it.',
      },
      {
        src: 'https://a.storyblok.com/f/152150/3772x5030/d586972268/dscf8628.jpg',
        alt: 'Console sitting on tv console, workout playing on screen.',
      },
      {
        src: 'https://a.storyblok.com/f/152150/6000x4000/800a1dc358/fc_product_shoot_2025-29.jpg',
        alt: 'FightCamp ankle wraps with trackers',
        focalPoint: { x: '45%', y: '40%' },
      },
    ],
  },
  {
    testShopifyId: 'gid://shopify/Product/7977374154841',
    prodShopifyId: 'gid://shopify/Product/8945313054956',
    pathId: 'fightcamp-core',
    title: 'Core',
    price: '$699',
    description: 'The ideal starter kit. Includes everything you need to transform any room into your personal boxing gym with our premium gear and tech.',
    includes: [
      consoleFourTrackers,
      fightcampQuickWraps,
      fightcampAnkleWraps,
      fightcampBoxingBag,
    ],
    includesBag: true,
    assets: [
      {
        src: 'https://a.storyblok.com/f/152150/1200x1120/2654bcb4bc/fcpackage_good.jpg',
        alt: 'FightCamp Package',
      },
      {
        src: 'https://a.storyblok.com/f/152150/6000x4000/561e2a02e5/thomas_stills-41.jpg',
        alt: 'FightCamp user taking boxing class in home gym, FightCamp workout playing on tv',
      },
      {
        src: 'xhttps://a.storyblok.com/f/152150/6000x4000/adaf5792c4/monica_room.jpg',
        alt: 'FightCamp user punching free standing bag',
      },
      {
        src: 'https://a.storyblok.com/f/152150/6000x4000/616d1e5c6f/gen2_aug2024_exports-1073-copy.jpg',
        alt: 'FightCamp bag in home gym setup',
      },
      {
        src: 'https://a.storyblok.com/f/152150/6000x4000/67bd62f9f9/fc_product_shoot_2025-115.jpg',
        alt: 'FightCamp Console and Trackers, wraps, and bag base',
      },
    ],
  },
  {
    testShopifyId: 'gid://shopify/Product/7977374220377',
    prodShopifyId: 'gid://shopify/Product/8945313317100',
    pathId: 'fightcamp-elite',
    title: 'Elite',
    price: '$899',
    description: 'The full FightCamp package. Premium gear, tech, and everything you\'ll need for the most immersive at home training from start to finish.',
    includes: [
      consoleFourTrackers,
      fightcampQuickWraps,
      fightcampAnkleWraps,
      fightcampBoxingBag,
      fightcampBagRing,
      fightcampGloves,
      fightcampHeartRateMonitor,
    ],
    includesBag: true,
    assets: [
      {
        src: 'https://a.storyblok.com/f/152150/1200x1120/e0bf6133e0/fcpackage_best.jpg',
        alt: 'FightCamp Package',
      },
      {
        src: 'https://a.storyblok.com/f/152150/6000x4000/1a9ac08669/gen2_aug2024_exports-811-copy.jpg',
        alt: 'FightCamp user taking kickboxing class',
        focalPoint: { x: '40%', y: '50%' },
      },
      {
        src: 'https://a.storyblok.com/f/152150/6192x8256/500aef4240/james-4.jpg',
        alt: 'FightCamp setup in home gym',
      },
      {
        src: 'https://a.storyblok.com/f/152150/6000x4000/62f63b92c9/fc_product_shoot_2025-21.jpg',
        alt: 'FightCamp quick wraps with trackers',
      },
      {
        src: 'https://a.storyblok.com/f/152150/4000x6000/53d53a1747/monica_stills-153.jpg',
        alt: 'Person working out with FightCamp',
      },
    ],
  },
];
